import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

import { AuthService } from 'src/app/seguranca/auth.service';
import { User } from '../../model/user.model';
import { ResetSenha } from '../../model/reset-senha.model';
import { CustomValidators } from 'ng2-validation';
import { UsuarioService } from 'src/app/usuario/usuario.service';
import { ToastrService } from 'ngx-toastr';

@Component({selector: 'app-menu', templateUrl: './menu.component.html', styleUrls: ['menu.component.css']})
export class MenuComponent implements OnInit {

    menuItems = [];
    user: User;
    isMenuCollapsed = true;
    letraNomeUser: string;
    form: UntypedFormGroup;
    novaSenha: ResetSenha;

    constructor(config: NgbModalConfig, private modalService: NgbModal, private authService: AuthService, private router: Router,
       private toast: ToastrService, private usuarioService: UsuarioService) {
      // customizar os valores default do modal.
      config.backdrop = 'static';
      config.keyboard = false;

        this.user = authService.getLoggedUser();
        if (this.user) {
          // Pegar a primeira letra do nome do usuário
          this.letraNomeUser = this.user.name.substring(0, 1);
        }
    }

    ngOnInit(): void {
      this.buildMenuOptions();

      // Construir o formulário.
      const senhaAtual = new UntypedFormControl('', Validators.required);
      const novaSenha = new UntypedFormControl('', Validators.required);
      const passwordConfirmation = new UntypedFormControl('', CustomValidators.equalTo(novaSenha));

      this.form = new UntypedFormGroup({
        senhaAtual: senhaAtual,
        novaSenha: novaSenha,
        passwordConfirmation: passwordConfirmation
      });
    }

    logout() {
        this.authService.logout();
        this.router.navigate(['']);
    }

    /**
     * Método responsável por definir a visibilidade do component
     */
    isComponentVisible(): boolean {
        return !this.authService.isAccessTokenInvalido();
    }

    // Método responsável por montar as opções do menu
    private buildMenuOptions() {

        this.menuItems = [];

        this.menuItems.push({
            text: 'Início',
            icon: 'fa fa-home',
            link: '/home',
            permissao: 'CONSULTAR_GRAFICOS',
            submenu: ''
        });

        this.menuItems.push({
            text: 'Atendimentos',
            icon: 'fa fa-list-alt',
            link: '/atendimentos',
            permissao: 'CONSULTAR_ATENDIMENTOS',
            submenu: ''
        });

        this.menuItems.push({
          text: 'Estatísticas',
          icon: 'fa fa-bar-chart',
          link: '/estatisticas',
          permissao: 'CONSULTAR_GRAFICOS_ADMINISTRATIVOS',
          submenu: ''
        });

        this.menuItems.push({
            text: 'Administração',
            icon: 'fa fa-cogs',
            link: '',
            permissao: 'EDITAR_MOD_ADMINISTRATIVO',
            submenu: this.getSettingsSubMenu()
        });

        this.menuItems.push({
          text: 'Administração',
          icon: 'fa fa-cogs',
          link: '',
          permissao: 'CONSULTAR_RELATORIO_ADMINISTRATIVO',
          submenu: this.getSettingsSubMenu()
      });
    }

    private getSettingsSubMenu() {
        const settingsSubMenu = [
            { text: 'Prestadores', link: '/prestadores', permissao: 'EDITAR_PRESTADORES' },
            { text: 'Procedimentos', link: '/procedimentos', permissao: 'EDITAR_PROCEDIMENTOS' },
            { text: 'Usuários', link: '/usuarios', permissao: 'EDITAR_USUARIOS' },
            { text: 'Relatorios', link: '/relatorio', permissao: 'CONSULTAR_RELATORIO_ADMINISTRATIVO' },
            { text: 'Relatorios', link: '/relatorio', permissao: 'EDITAR_MOD_ADMINISTRATIVO' },
            { text: 'Dependentes', link: '/dependente', permissao: 'EDITAR_USUARIOS' }
        ];

        return settingsSubMenu;
    }

 /**
   * Método responsável por preparar o modal para alterar a senha do usuário.
   * @param content dados do template do modal.
   */
  modalAlterarSenha(content) {
    // Inicializar o objeto toda vez que o modal for chamado
    this.form.reset();

    this.novaSenha = new ResetSenha();
    this.modalService.open(content);
  }

  // Método responsável por realizar a requisição para alterar a senha do usuário.
  alterarSenha() {
    this.novaSenha.senhaAtual = this.form.get('senhaAtual').value;
    this.novaSenha.novaSenha = this.form.get('novaSenha').value;

    this.usuarioService.alterarSenha(this.user.id, this.novaSenha).subscribe(
        () => {
          this.toast.success('Senha alterada com sucesso!');
          // Fechar o modal.
          this.modalService.dismissAll();
        },
        responseError => this.toast.error(responseError.error.detalhe)
    );
  }
}
